import Handlebars from "handlebars/runtime";
import moment from 'moment';
import flatpickr from 'flatpickr';
import HoustonZooApi from "../../services/HoustonZooApi";
import InputCounter from "../InputCounter";
import TimeConvert from "../../helpers/timeConvert";

// Templates
import TicketsTpl from "../../handlebars/dinosaur-exhibit/Tickets.handlebars";
import AddOnTpl from "../../handlebars/dinosaur-exhibit/Addon.handlebars";
import ArrivalTimeTpl from "../../handlebars/dinosaur-exhibit/ArrivalTime.handlebars";

Handlebars.registerHelper(
  "toStandardTime",
  (timeIn24hr) => TimeConvert.convertFrom24To12Format(timeIn24hr)
);

const DEBuyTickets = (() => {
  const DOM = {};
  let date = '';
  // let timeslot = '';
  let visitors = [];
  let totalVistors = 0;
  let totalValuePasses = 0;
  let extras = [];
  let totalExtras = 0;
  let visitorFrmData = '';
  let addOnFrmData = '';
  let skipAddons = true;

  const cacheDOM = () => {
    DOM.buyTicketsComponent = document.getElementById('de-buy-tickets');
  };

  const updateTicketSelections = () => {
    const ticketFormElem = document.getElementById('frm-ticket-selection');
    if (ticketFormElem) {
      const formData = new FormData(ticketFormElem);
      const adultQty = isNaN(parseInt(formData.get('qty-adult'))) ? 0 : parseInt(formData.get('qty-adult'));
      const childQty = isNaN(parseInt(formData.get('qty-child'))) ? 0 : parseInt(formData.get('qty-child'));
      const seniorQty = isNaN(parseInt(formData.get('qty-senior'))) ? 0 : parseInt(formData.get('qty-senior'));
      const infantQty = isNaN(parseInt(formData.get('qty-infant'))) ? 0 : parseInt(formData.get('qty-infant'));
      visitorFrmData = formData;
      totalVistors = adultQty + childQty + seniorQty + infantQty;

      // Set visitors
      visitors = [];

      if (adultQty > 0) {
        visitors.push({
          plu: 'EV4001',
          qty: adultQty,
        });
      }
      if (childQty > 0) {
        visitors.push({
          plu: 'EV4002',
          qty: childQty,
        });
      }
      if (seniorQty > 0) {
        visitors.push({
          plu: 'EV4003',
          qty: seniorQty,
        });
      }
      if (visitorFrmData.get('qty-infant') > 0) {
        visitors.push({
          plu: 'WTT70404',
          qty: infantQty,
        });
      }
      totalValuePasses = totalVistors - infantQty;
    }

    extras = [];
    // extras.push({
    //   plu: 'EV1003',
    //   qty: totalValuePasses,
    // });

    const addOnFormElem = document.getElementById('frm-addon');
    if (addOnFormElem) {
      const addOnFormData = new FormData(addOnFormElem);
      const extraWaterQty = isNaN(parseInt(addOnFormData.get('qty-extra-water'))) ? 0 : parseInt(addOnFormData.get('qty-extra-water'));
      totalExtras = extraWaterQty;
      addOnFrmData = addOnFormData;
      // if (addOnFrmData.get('qty-extra-water') > 0) {
      //   extras.push({
      //     plu: 'FB0022',
      //     qty: extraWaterQty,
      //   });
      // }
    }
  };

  const updateAvailability = (DatePickerEl) => {
    updateTicketSelections();
    const currentMonth = DatePickerEl.currentMonth + 1;
    const { currentYear } = DatePickerEl;
    const { defaultDate } = DatePickerEl;
    HoustonZooApi.getAvailability(currentMonth, currentYear, totalVistors, 'dinosaur-exhibit').then(prices => {
      const availability = Object.keys(prices);
      if (Array.isArray(availability) && availability.length) {
        DatePickerEl.set('enable', availability);
        DatePickerEl.set('onDayCreate', (dObj, dStr, fp, dayElem) => {
          const eventDate = DatePickerEl.formatDate(dayElem.dateObj, "Y-m-d");
          if (eventDate in prices && 'EV4001' in prices[eventDate] && 'lowest_price' in prices[eventDate]['EV4001']) {
            dayElem.innerHTML += `<span class="from-price">from ${prices[eventDate]['EV4001']['lowest_price']}</span>`;
          } else {
            dayElem.innerHTML += `<span class="from-price">&nbsp;</span>`;
          }
        });
        DatePickerEl.set('defaultDate', defaultDate);
        DatePickerEl.redraw();
      } else {
        DatePickerEl.set('enable', ["1900-01-01"]);
      }
    });
  };

  const initDatePicker = (elem, defaultDate = null) => {
    const today = new Date();
    const eventStartDate = new Date(2024, 2, 8);
    return flatpickr(elem, {
      defaultDate,
      minDate: eventStartDate > today ? eventStartDate : today,
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: "m/d/Y",
      enable: ["1900-01-01"],
      appendTo: document.querySelector('#datepicker-placeholder'),
      position: "above center",
      positionElement: document.querySelector('#datepicker'),
      // inline: true,
      wrap: true,
      ignoredFocusElements: [window.document.body],
      onMonthChange: [
        (selectedDates, dateStr, instance) => {
          updateAvailability(instance);
        }
      ],
      onYearChange: [
        (selectedDates, dateStr, instance) => {
          updateAvailability(instance);
        }
      ],
      onOpen: [
        (selectedDates, dateStr, instance) => {
          updateAvailability(instance);
        }
      ],
    });
  };

  const showArrivalTimes = () => {
    const eventDate = moment(date).format('YYYY-MM-DD');
    HoustonZooApi.getTimeslots(eventDate, visitors, extras, 'dinosaur-exhibit').then(timeslots => {
      DOM.buyTicketsComponent.innerHTML = ArrivalTimeTpl({
        date: moment(date).format('ddd MMM D, YYYY'),
        timeslots,
        skipAddons,
      });
      DOM.buyTicketsComponent.querySelector('.hide').classList.add("show");
      setTimeout(() => {
        DOM.buyTicketsComponent.querySelector('.hide').classList.remove("hide");
      }, 300);
      document.getElementById('frm-arrival-time')
        .querySelectorAll('input[name="time"]')
        .forEach((elem) => {
          elem.addEventListener(
            'change',
            (e) => {
              document.querySelector('.preloader--timeslots')
                .classList
                .remove('preloader--disable');
              document.getElementById('frm-arrival-time').scrollIntoView();
              setTimeout(() => {
                window.location.href = e.target.getAttribute('data-deeplink');
              }, 300);
            }
          );
        });
    });
  };

  const showGATickets = () => {
    DOM.buyTicketsComponent.innerHTML = TicketsTpl({
      date,
      visitors,
      visitorFrmData
    });

    const formElem = document.getElementById('frm-ticket-selection');
    let selectedDate = null;

    // Repopulate form data
    if (visitorFrmData instanceof FormData) {
      if (visitorFrmData.get('qty-adult')) {
        formElem.elements['qty-adult'].value = visitorFrmData.get('qty-adult');
      }
      if (visitorFrmData.get('qty-child')) {
        formElem.elements['qty-child'].value = visitorFrmData.get('qty-child');
      }
      if (visitorFrmData.get('qty-senior')) {
        formElem.elements['qty-senior'].value = visitorFrmData.get('qty-senior');
      }
      if (visitorFrmData.get('qty-infant')) {
        formElem.elements['qty-infant'].value = visitorFrmData.get('qty-infant');
      }
      if (visitorFrmData.get('date')) {
        selectedDate = visitorFrmData.get('date');
      }
    }

    // Init modules
    initDatePicker('#datepicker', selectedDate);
    InputCounter.init();

    DOM.buyTicketsComponent.querySelector('.hide').classList.add("show");
    setTimeout(() => {
      DOM.buyTicketsComponent.querySelector('.hide').classList.remove("hide");
    }, 300);

    // On show tickets
    formElem.addEventListener("submit", (e) => {
      e.preventDefault();
      updateTicketSelections();

      if (visitorFrmData.get('date')) {
        const dateParts = visitorFrmData.get('date').split('-');
        date = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);
      }

      let frmErrorMsg = '';
      let frmError = false;

      // Remove form errors
      document.querySelectorAll('.invalid-feedback').forEach((elem) => {
        elem.remove();
      });

      // Validate date
      if (!Date.parse(date)) {
        frmError = true;
        frmErrorMsg = 'Please select your admission date';
      }

      // Validate visitors
      if (totalVistors < 1) {
        frmError = true;
        frmErrorMsg = 'Please specify the number of visitors in your booking';
      }

      if (totalVistors >= 20) {
        frmError = true;
        frmErrorMsg = `If purchasing more than 20 tickets use our
<a href="https://tickets.houstonzoo.org/webstore/shop/viewitems.aspx?CG=GROUPGA&C=GROUPGAEVENTS&companycode=GROUPADMISSION" target="_blank">group discount tickets</a>`;
      }

      // Exit if form errors
      if (frmError) {
        document.getElementsByClassName('ticket-selection')[0]
          .insertAdjacentHTML(
            'afterend',
            `<p class="invalid-feedback" style="display:block">${frmErrorMsg}</p>`
          );
        return;
      }

      if (skipAddons) {
        totalExtras = 0;
        extras = [];
        addOnFrmData = '';
        showArrivalTimes();
      } else {
        showAddOns();
      }
    });
  };

  const updateCounters = () => {
    const inputCounters = document.querySelectorAll('.input-counter__input');
    let addonCount = 0;
    inputCounters.forEach((elem) => {
      addonCount += parseInt(elem.value, 10);
    });
    const submitBtn = document.getElementById('addonformSubmit');
    if (addonCount > 0) {
      submitBtn.value = `Add Selected Enhancements (${addonCount})`;
    } else {
      submitBtn.value = `Skip Enhancements`;
    }
  };

  const showAddOns = () => {
    HoustonZooApi.getAddons(4).then(addOns => {
      DOM.buyTicketsComponent.innerHTML = AddOnTpl({
        addOns,
        addOnFrmData
      });

      const formElem = document.getElementById('frm-addon');
      // Repopulate form data
      if (addOnFrmData instanceof FormData) {
        if (addOnFrmData.get('qty-extra-water')) {
          formElem.elements['qty-extra-water'].value = addOnFrmData.get('qty-extra-water');
        }
      }

      // Init modules
      InputCounter.init();

      // Add vent listeners
      const inputCounters = document.querySelectorAll('.input-counter__input');
      updateCounters();

      inputCounters.forEach((elem) => {
        elem.addEventListener('input', () => {
          updateCounters();
        });
      });

      DOM.buyTicketsComponent.querySelector('.hide').classList.add("show");
      setTimeout(() => {
        DOM.buyTicketsComponent.querySelector('.hide').classList.remove("hide");
      }, 300);

      // On show tickets
      formElem.addEventListener("submit", (e) => {
        e.preventDefault();
        updateTicketSelections();
        showArrivalTimes();
        DOM.buyTicketsComponent.scrollIntoView();
      });
    });
  };

  const goToStep = (step) => {
    switch (step) {
      case "ga-tickets":
        showGATickets();
        DOM.buyTicketsComponent.scrollIntoView();
        break;
      case "addon":
        showAddOns();
        DOM.buyTicketsComponent.scrollIntoView();
        break;
      case "arrival-time":
        showArrivalTimes();
        DOM.buyTicketsComponent.scrollIntoView();
        break;
      default:
        showGATickets();
        DOM.buyTicketsComponent.scrollIntoView();
        break;
    }
  };

  const init = () => {
    cacheDOM();
    if (DOM.buyTicketsComponent) {
      showGATickets();
      document.addEventListener('click', (e) => {
        if (e.target && e.target.classList.contains('js-progress-step')) {
          e.preventDefault();
          goToStep(e.target.getAttribute("data-progress-step"));
        }
      });
    }
  };

  return {
    init
  };
})();

export default DEBuyTickets;
